import React, { useState } from 'react';
import './Header.css';

const Header = ({ currentPage, setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Digital Flourishing', isHome: true },
    { id: 'programs', label: 'Our Programs' },
    { id: 'pilot', label: 'Pilot Program' },
    { id: 'resources', label: 'Resources' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' }
  ];

  const handleNavClick = (pageId) => {
    setCurrentPage(pageId);
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo and Site Title */}
          <div className="header-brand" onClick={() => handleNavClick('home')}>
            <img 
              src="https://static.wixstatic.com/media/1d90b3_588e219d6cc2449d84256529ea18235d~mv2.png" 
              alt="Digital Flourishing for Young Minds" 
              className="header-logo"
            />
            <div className="header-title">
              <h1>12 Months to Flourish</h1>
              <span className="header-subtitle">Digital Flourishing for Young Minds</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`nav-link ${currentPage === item.id ? 'active' : ''} ${item.isHome ? 'home-link' : ''}`}
                onClick={() => handleNavClick(item.id)}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="nav-mobile">
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`nav-link-mobile ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => handleNavClick(item.id)}
              >
                {item.label}
              </button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
